import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useSortingData } from "../../stores/sorting.store";

const NavCategory = ({ icon, title = "", active = false, keyNavigateTo }) => {
    const navigate = useNavigate();
    const store_sort = useSortingData();

    return (
        <Wrapper
            className={active ? "active" : ""}
            onClick={() => {
                store_sort.reset();
                navigate(keyNavigateTo);
            }}
        >
            {icon}
            <Title>{title}</Title>
        </Wrapper>
    );
};

export default NavCategory;

const Title = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const Wrapper = styled(Flex)`
    display: flex;
    width: 203px;
    padding: 8px 12px;
    align-items: center;
    gap: var(--spacing-xs-8, 8px);
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #f0f0f0;
    }
    &.active {
        background-color: #e8ebfa;
        ${Title} {
            color: var(
                --Light-theme-Active-Foreground-Brand-Foreground-Active,
                #5b5fc7
            );

            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px; /* 142.857% */
        }
    }
`;
